import React from "react";
import {
  Container,
  Typography,
  useTheme,
  LinearProgress,
  Button,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
  IconButton,
  Box,
  colors,
  TextField as MuiTextField,
  MenuItem,
  Paper,
  Divider,
  Fade,
} from "@material-ui/core";
import * as Yup from "yup";

import CameraAltIcon from "@material-ui/icons/CameraAlt";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PrintIcon from "@material-ui/icons/Print";
import RefreshIcon from "@material-ui/icons/Refresh";
import DescriptionIcon from "@material-ui/icons/Description";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import { TextField } from "formik-material-ui";
import CloseIcon from "@material-ui/icons/Close";

import { formatDate } from "../../../common/formatDate";
import { LSDBSplitButton } from "../../../common/LSDBSplitButton";
import {
  useResults,
  usesubmitProcedure,
  useTestPermissions,
  useUnitNotes,
} from "../../projectQueries";
import { useProcedureComments, useSubmitComment, useUnitsBySerialNumber } from "../../../testCommunication/common/testQueries";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { DiodeTestModal } from "../../../dataEgress/DiodeTestModal";
import { ELImageReviewModal } from "../../../dataEgress/ELImageReviewModal";
import { ColorimeterReviewModal } from "../../../dataEgress/ColorimeterModal";
import { VisualInspectionReviewModal } from "../../../dataEgress/VisualInspectionReviewModal";
import { LeakedDataModal } from "../../../dataEgress/LeakedDataModal";
import { IVReviewModal } from "../../../dataEgress/IVReview/IVReviewModal";
import { VisualizerModal } from "../../../testCommunication/common/VisualizerModal";
import { ViewAddNoteList } from "../../../common/ViewAddNotes";
import { ImageListModal } from "../../../common/imageViewerModal";
import { useAddNoteToUnit } from "../../projectManagementMutations";
import { useQueryClient } from "react-query";
import SaveAltIcon from "@material-ui/icons/SaveAlt";

import {
  useUnitsDispositions,
  usePatchUnit,
  useDispositionsByName,
} from "../../../common/services/dispositionServices";

import { toast } from "react-toastify";
import { useFetchContext } from "../../../common/FetchContext";

import { useAuthContext } from "../../../common/AuthContext";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { processErrorOnMutation } from "../../../../util/errorMessaging";
import { useHistory } from "react-router-dom";
import { StressDataModal } from "../../../dataEgress/StressDataModal";
import { ThreadedCreator } from "../../../common/threadedViewer/threadedCreator";
import { IntakeImages } from "./IntakeImages";
import { urls } from "../../../common/urls";
import moment from "moment";
import { red } from "@material-ui/core/colors";
import { getTheme } from "../../../common/getLocalTheme";
import { PanIamModel } from "../../../dataEgress/PanIamModel";
import { EdgePinchModel } from "../../../dataEgress/EdgePinchModel";
import { EdgeRetestComponent } from "../fileUpload/EdgePinch/EdgeRetestComponent";
import RichTextEditor from "react-rte";
import { Field, Form, Formik } from "formik";
import { ThreadedTaggedUsers } from "../../../common/threadedViewer/threadedTaggedUsers";
import { ThreadedFileModal } from "../../../common/threadedViewer/threadedFileModal";
import { usePostFile } from "../../../common/services/fileServices";
import { InsulationDataModal } from "../../../dataEgress/InsulationDataModal";

const useStyles = makeStyles(() => ({
  baseBorder: {
    borderStyle: "solid",
    borderWidth: "1px",
  },
}));

export const TravelerComponent = ({ serialNumber }: any) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const { dispatch } = useAuthContext();
  const { authAxios } = useFetchContext();
  const queryClient = useQueryClient();

  const [isHistoricModalOpen, setIsHistoricModalOpen] = React.useState(false);
  const [currentHistoricData, setCurrentHistoricData] = React.useState(null);
  const [imageModal, setImageModal] = React.useState(false);

  const [openChooseProcedureDialog, setOpenChooseProcedureDialog] =
    React.useState(false);
  const [selectedProcedure, setSelectedProcedure] = React.useState<any>(null);
  const [isIntakeDetailOpen, setIsIntakeDetailOpen] = React.useState(false);

  const [openEdgePinchDialog, setopenEdgePinchDialog] = React.useState(false);

  const [selectedSerialNumber, setSelectedSerialNumber] =
    React.useState<string>("");

  const [taggedUsers, setTaggedUsers] = React.useState<any[]>([]);
  const [files, setFiles] = React.useState<any[]>([]);
  const [text, setText] = React.useState(RichTextEditor.createEmptyValue());

  const [selectedProcedureId, setSelectedProcedureId] = React.useState<
    string | null
  >(null);
  const [openNotesDialog, setOpenNotesDialog] = React.useState(false);
  const [openAddNoteDialog, setOpenAddNoteDialog] = React.useState(false);

  const { mutateAsync: mutateAddNote } = useAddNoteToUnit();
  const { mutateAsync: mutatePatchUnit } = usePatchUnit();
  const { mutateAsync: mutate } = useSubmitComment();
  const { mutateAsync: mutatePostFile } = usePostFile();

  const {
    mutateAsync: mutateSubmitStress,
    isLoading: submitStressProcedureLoading,
  } = usesubmitProcedure();

  const {
    error: errorUnits,
    data: units,
    isError: isErrorUnits,
    isSuccess: isSuccessUnits,
    isLoading: isLoadingUnits,
  } = useUnitsBySerialNumber(serialNumber);

  const {
    error: errorResults,
    data: travelerResults,
    isError: isErrorResults,
    isSuccess: isSuccessResults,
    isLoading: isLoadingResults,
  } = useResults(units && units.length > 0 ? units[0].id : null);

  const {
    data: permission,
    isLoading: isLoadingPermission,
    isError: isErrorPermission,
    error: errorPermission,
  } = useTestPermissions();

  const {
    error: errorDispositions,
    data: dispositions,
    isSuccess: isSuccessDispositions,
    isLoading: isLoadingDispositions,
    isError: isErrorDispositions,
  } = useUnitsDispositions();

  const {
    data: dispositionPassed,
    isLoading: isLoadingDispositionPassed,
    isError: isErrorDispositionPassed,
    error: errorDispositionPassed,
    isSuccess: isSuccessDispositionPassed,
  } = useDispositionsByName("Pass");

  const {
    data: dispositionStopTesting,
    isLoading: isLoadingDispositionStopTesting,
    isError: isErrorDispositionStopTesting,
    error: errorDispositionStopTesting,
    isSuccess: isSuccessDispositionStopTesting,
  } = useDispositionsByName("Fail - Stop Testing");

  const { data: notes, isLoading } = useProcedureComments(
    selectedProcedureId,
    openNotesDialog,
  );

  const handleVerify = async () => {
    if (!selectedProcedure?.selected_definition_id) {
      toast.error("Please select a valid procedure before verifying");
      return;
    }
    try {
      await mutateSubmitStress({
        authAxios,
        procedure_result_id: selectedProcedure.id,
        procedure_definition_id: selectedProcedure.selected_definition_id,
      });
      toast.success(`Update the procedure successfully`);
      queryClient.invalidateQueries("travelerResults");
    } catch (e) {
      toast.error(
        e?.response?.data?.message || "Unable to update the procedure",
      );
      queryClient.invalidateQueries("travelerResults");
    }

    setOpenChooseProcedureDialog(false);
  };

  React.useEffect(() => {
    if (isSuccessUnits && units.length === 0) {
      toast.error(`No units found.`);
    }
  }, [isSuccessUnits, isSuccessResults, units, travelerResults]);

  const addTime = (dateString: any, duration: number) => {
    const oldDate = new Date(dateString);
    const newDate = new Date(oldDate.getTime() + duration * 60000);
    return formatDate(newDate.toString());
  };

  if (isErrorUnits || isErrorResults || isErrorDispositions) {
    return (
      <>
        {isErrorUnits && <ErrorMessage error={errorUnits} />}
        {isErrorResults && <ErrorMessage error={errorResults} />}
        {isErrorDispositions && <ErrorMessage error={errorDispositions} />}
        {isErrorDispositionPassed && (
          <ErrorMessage error={errorDispositionPassed} />
        )}
      </>
    );
  }

  if (
    isLoadingUnits ||
    isLoadingResults ||
    isLoadingPermission ||
    isLoadingDispositions ||
    isLoadingDispositionPassed
  ) {
    return (
      <div style={theme.containerMargin}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
          spacing={4}
        >
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        </Grid>
      </div>
    );
  }

  const downloadIntakeData = async (): Promise<any> => {
    try {
      const response = await authAxios.get(
        urls.units.downloadIntakeInfo(serialNumber),
        {
          responseType: "blob",
        },
      );

      const downloadUrl = URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
      document.body.appendChild(a);
      a.click();
    } catch (err) {
      toast.error(`data not available`);
    }
  };

  const renderUnitDisposition = () => {
    if (travelerResults.disposition_name) {
      if (permission && !getTheme()) {
        return (
          <LSDBSplitButton
            onItemSelection={submitDisposition}
            options={dispositions}
            idField="id"
            textField="name"
            selectedItemText={travelerResults.disposition_name}
          />
        );
      } else {
        return (
          <>
            <Typography variant="body2" align="center" display="inline">
              Disposition:
            </Typography>
            <Typography
              variant="body2"
              align="center"
              display="inline"
              style={{ color: "grey" }}
            >
              {travelerResults.disposition_name}
            </Typography>
          </>
        );
      }
    } else {
      return (
        <>
          <Typography variant="body2" align="center" display="inline">
            Disposition:
          </Typography>
          <Typography
            variant="body2"
            align="center"
            display="inline"
            style={{ color: "grey" }}
          >
            {"N/A"}
          </Typography>
        </>
      );
    }
  };

  const renderVisualizerModal = (procedure: any) => {
    const dispositionName = permission ? procedure.disposition_name : null;
    switch (procedure.visualizer) {
      case "el_image":
        return (

          <>
           
                <ELImageReviewModal
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>

        );
      case "iv_curve":
        return (
          <>
            
                <IVReviewModal
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                  isCustomCurve={procedure.is_custom_curve}
                />
              
          </>
        );
      case "wet_leakage":
        return (
          <>
            
                <LeakedDataModal
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>
        );
      case "visual_inspection":
        return (
          <>
            
                <VisualInspectionReviewModal
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  failed={dispositionStopTesting?.url}
                  unit_id={units[0].id}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>
        );
      case "diode":
        return (
          <>
            
                <DiodeTestModal
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>
        );
      case "colorimeter":
        return (
          <>
            
                <ColorimeterReviewModal
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>
        );
      case "stress":
        return (
         
              <StressDataModal
                id={procedure.id}
                disposition={dispositionName}
                name={procedure.procedure_definition_name}
                dispositionPassedId={dispositionPassed?.id}
                open_notes={procedure.open_notes}
                has_notes={procedure.has_notes}
                isComments={procedure.is_comments}
                onOpenNotes={() => {
                  setSelectedProcedureId(procedure.id);
                  setOpenNotesDialog(true);
                }}
              />
            
        );
      case "pan":
        return (
          <>
            
                <PanIamModel
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>
        );

      case "iam":
        return (
          <>
            
                <PanIamModel
                  id={procedure.id}
                  disposition={dispositionName}
                  name={procedure.procedure_definition_name}
                  dispositionPassedId={dispositionPassed?.id}
                  open_notes={procedure.open_notes}
                  has_notes={procedure.has_notes}
                  isComments={procedure.is_comments}
                  onOpenNotes={() => {
                    setSelectedProcedureId(procedure.id);
                    setOpenNotesDialog(true);
                  }}
                />
              
          </>
        );

      case "edge_pinch":
        return (
          
              <EdgePinchModel
                id={procedure.id}
                disposition={dispositionName}
                name={procedure.procedure_definition_name}
                dispositionPassedId={dispositionPassed?.id}
                open_notes={procedure.open_notes}
                has_notes={procedure.has_notes}
                isComments={procedure.is_comments}
                onOpenNotes={() => {
                  setSelectedProcedureId(procedure.id);
                  setOpenNotesDialog(true);
                }}
              />
            
        );
        case "insulation_test":
        return (
          <InsulationDataModal
            id={procedure.id}
            disposition={dispositionName}
            name={procedure.procedure_definition_name}
            dispositionPassedId={dispositionPassed?.id}
            open_notes={procedure.open_notes}
            has_notes={procedure.has_notes}
            isComments={procedure.is_comments}
            onOpenNotes={() => {
              setSelectedProcedureId(procedure.id);
              setOpenNotesDialog(true);
            }}
          />
        );
      default:
        return (
          <Typography variant="body2" align="center">
            {procedure.procedure_definition_name}
          </Typography>
        );
    }
  };

  const renderProcedureName = (procedure: any) => {
    if (procedure.visualizer === "stress" && procedure.is_dynamic) {
      return (
        <Button
          variant="outlined"
          color="primary"
          fullWidth
          onClick={() => {
            setSelectedProcedure(procedure);
            setOpenChooseProcedureDialog(true);
          }}
        >
          <Typography variant="body2" align="center">
            Choose the Stress
          </Typography>
        </Button>
      );
    }

    if (procedure.visualizer === "edge_pinch" && procedure.edgepinch_retest) {
      return (
        <Grid
          container
          alignItems="center"
          wrap="nowrap"
          spacing={1}
          style={{ width: "100%" }}
        >
          <Grid item style={{ flex: 1 }}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                setSelectedSerialNumber(procedure);
                setopenEdgePinchDialog(true);
              }}
            >
              <Typography variant="body2" align="center">
                Retest Edge Pinch
              </Typography>
            </Button>
          </Grid>

          <Grid item>
            <IconButton
              size="small"
              onClick={() => {
                setSelectedProcedureId(procedure.id);
                setOpenNotesDialog(true);
              }}
            >
              {procedure.is_comments ? (
                <DescriptionIcon fontSize="small" style={{ color: "green" }} />
              ) : (
                <NoteAddIcon fontSize="small" color="primary" />
              )}
            </IconButton>
          </Grid>
        </Grid>
      );
    }

    if (history.location.pathname.includes("virtual_traveler") && permission) {
      return (
        <>
          <>
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={1}
              wrap="nowrap"
              style={{ width: "100%" }}
            >
              <Grid item xs>
                <Button
                  style={{ textAlign: "center" }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setCurrentHistoricData(procedure);
                    setIsHistoricModalOpen(true);
                  }}
                  fullWidth
                >
                  <Typography variant="body2">
                    {procedure.procedure_definition_name}
                  </Typography>
                </Button>
              </Grid>
              {!getTheme() && (
                <Grid item>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSelectedProcedureId(procedure.id);
                      setOpenNotesDialog(true);
                    }}
                  >
                    {procedure.is_comments ? (
                      <DescriptionIcon
                        fontSize="small"
                        style={{ color: "green" }}
                      />
                    ) : (
                      <NoteAddIcon fontSize="small" color="primary" />
                    )}
                  </IconButton>
                </Grid>
              )}
            </Grid>
          </>
        </>
      );
    }

    return (
      <>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          wrap="nowrap"
          style={{ width: "100%" }}
        >
          <Grid item style={{ flex: 1, padding: 4 }}>
            <Typography
              variant="body2"
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {procedure.procedure_definition_name}
            </Typography>

            {procedure.procedure_definition_name === "Visual Inspection" &&
              procedure.is_aknowledged ? (
              <Typography variant="caption" align="center" style={{ color: "red" }}>
                Acknowledged by: {procedure.acknowledged_by}
              </Typography>
            ) : null}
          </Grid>

          {!getTheme() && (
            <Grid item>
              <IconButton
                size="small"
                onClick={() => {
                  setSelectedProcedureId(procedure.id);
                  setOpenNotesDialog(true);
                }}
              >
                {procedure.is_comments ? (
                  <DescriptionIcon
                    fontSize="small"
                    style={{ color: "green" }}
                  />
                ) : (
                  <NoteAddIcon fontSize="small" color="primary" />
                )}
              </IconButton>
            </Grid>
          )}
        </Grid>
      </>
    );
  };

  const submitDisposition = async (selectedDisposition: any) => {
    try {
      await mutatePatchUnit({
        authAxios,
        id: units[0].id,
        field: "disposition",
        value: selectedDisposition.url,
      });
      toast.success("Disposition saved");
      queryClient.invalidateQueries("travelerResults");
    } catch (error) {
      queryClient.invalidateQueries("travelerResults");
      processErrorOnMutation(error, dispatch, history);
    }
  };

  function handleOpenIntakeDetails(): void {
    setIsIntakeDetailOpen(true);
  }

  return (
    <Container>
      {isSuccessResults &&
        isSuccessUnits &&
        isSuccessDispositions &&
        isSuccessDispositionPassed && (
          <>
            <Grid container direction="row">
              <Grid item xs={8} className={classes.baseBorder}>
                <Grid container>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Project Number
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    {travelerResults.project_number ? (
                      <Typography variant="body2" align="center">
                        {travelerResults.project_number}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        align="center"
                        style={{ color: "grey" }}
                      >
                        N/A
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Work Order
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    {travelerResults.work_order_name ? (
                      <Typography variant="body2" align="center">
                        {travelerResults.work_order_name}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        align="center"
                        style={{ color: "grey" }}
                      >
                        N/A
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      NTP Date
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    {travelerResults.start_datetime ? (
                      <Typography variant="body2" align="center">
                        {formatDate(travelerResults.start_datetime)}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        align="center"
                        style={{ color: "grey" }}
                      >
                        N/A
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Mpp
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.module_property.nameplate_pmax}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Manufacturer
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.manufacturer_name}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Voc
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.module_property.voc}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Model
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.model}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Isc
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.module_property.isc}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Project Manager
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    {travelerResults.project_manager ? (
                      <Typography variant="body2" align="center">
                        {travelerResults.project_manager}
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        align="center"
                        style={{ color: "grey" }}
                      >
                        N/A
                      </Typography>
                    )}
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Vmp
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.module_property.vmp}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Customer
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.customer_name}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Imp
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.module_property.imp}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Calibration
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {
                        travelerResults.unit_type.module_property
                          .module_technology_name
                      }
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Voltage
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {travelerResults.unit_type.module_property.system_voltage}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Dimensions
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      {`${travelerResults.unit_type.module_property.module_height} x ${travelerResults?.unit_type.module_property.module_width}`}
                    </Typography>
                  </Grid>

                  <Grid item xs={3} className={classes.baseBorder}>
                    <Typography variant="body2" align="center">
                      Bifacial
                    </Typography>
                  </Grid>
                  <Grid item xs={3} className={classes.baseBorder}>
                    {travelerResults.unit_type.module_property.bifacial ===
                      true && (
                        <Typography variant="body2" align="center">
                          True
                        </Typography>
                      )}
                    {travelerResults.unit_type.module_property.bifacial ===
                      false && (
                        <Typography variant="body2" align="center">
                          False
                        </Typography>
                      )}
                    {travelerResults.unit_type.module_property.bifacial ===
                      null && (
                        <Typography
                          variant="body2"
                          align="center"
                          style={{ color: "grey" }}
                        >
                          {" N/A"}
                        </Typography>
                      )}
                  </Grid>
                </Grid>
                <Grid item xs={6} className={classes.baseBorder}>
                  <Typography variant="body2" align="center">
                    Location :{" "}
                    {travelerResults.location
                      ? travelerResults.location
                      : "N/A"}
                  </Typography>
                </Grid>
              </Grid>

              <Grid item xs={4} className={classes.baseBorder}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justify="center"
                >
                  <Grid item xs={12} />
                  <Grid item xs={7}>
                    <Grid container alignItems="center" direction="column">
                      <Grid item xs={12}>
                        {travelerResults.test_sequence_definition_name ? (
                          <Typography variant="body2" align="center">
                            {travelerResults.test_sequence_definition_name}
                          </Typography>
                        ) : (
                          <Typography variant="body2" align="center">
                            No Test Sequence Found
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        {travelerResults.test_sequence_definition_version ? (
                          <Typography variant="body2" align="center">
                            {travelerResults.test_sequence_definition_version}
                          </Typography>
                        ) : null}
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="body2" align="center">
                          Unit Serial Number: {serialNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        {travelerResults.project_manager ? (
                          <Typography variant="body2" align="center">
                            Project Manager: {travelerResults.project_manager}
                          </Typography>
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              align="center"
                              display="inline"
                            >
                              Project Manager:
                            </Typography>
                            <Typography
                              variant="body2"
                              align="center"
                              display="inline"
                              style={{ color: "grey" }}
                            >
                              {" N/A"}
                            </Typography>
                          </>
                        )}
                      </Grid>
                      <Grid item xs={12}>
                        {travelerResults.intake_date ? (
                          <Typography variant="body2" align="center">
                            Intake Date:{" "}
                            {formatDate(travelerResults.intake_date)}
                          </Typography>
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              align="center"
                              display="inline"
                            >
                              Intake Date:
                            </Typography>
                            <Typography
                              variant="body2"
                              align="center"
                              display="inline"
                              style={{ color: "grey" }}
                            >
                              {" N/A"}
                            </Typography>
                          </>
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        {renderUnitDisposition()}
                      </Grid>

                      <Grid item xs={12}>
                        {travelerResults.tib ? (
                          <Typography variant="body2" align="center">
                            TIB: {travelerResults.tib}
                          </Typography>
                        ) : (
                          <>
                            <Typography
                              variant="body2"
                              align="center"
                              display="inline"
                            >
                              TIB:
                            </Typography>
                            <Typography
                              variant="body2"
                              align="center"
                              display="inline"
                              style={{ color: "grey" }}
                            >
                              {" N/A"}
                            </Typography>
                          </>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={5}>
                    <Grid
                      container
                      alignItems="center"
                      justify="space-between"
                      direction="row"
                      spacing={1}
                    >
                      <Grid item xs={5}>
                        <Tooltip title="View Notes">
                          <ViewAddNoteList
                            id={travelerResults.id}
                            type={1}
                            count={travelerResults.notes[0]?.count}
                            unread={travelerResults.notes[0]?.unread_count}
                            model={"unit"}
                            invalidate={[
                              "travelerResults",
                              ["unit_notes", travelerResults.id],
                            ]}
                            getNotes={useUnitNotes}
                          />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={1} />
                      <Grid item xs={6}>
                        <Tooltip title="View Images">
                          <Button
                            style={{ textAlign: "center" }}
                            variant="contained"
                            disabled={getTheme()}
                            onClick={() => {
                              setImageModal(!imageModal);
                            }}
                            startIcon={<CameraAltIcon />}
                          />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6}>
                        <Tooltip title="Copy to Clipboard">
                          <CopyToClipboard
                            text={`${location.hostname}/project_management/virtual_traveler/${serialNumber}`}
                            onCopy={() =>
                              toast.success(`Copied Link to Clipboard.`)
                            }
                          >
                            <Button
                              style={{ textAlign: "center" }}
                              variant="contained"
                              color="primary"
                              startIcon={<FileCopyIcon />}
                            />
                          </CopyToClipboard>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={6}>
                        <Button
                          style={{ textAlign: "center" }}
                          variant="contained"
                          disabled
                          startIcon={<PrintIcon />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Tooltip title="Refresh Traveler">
                          <Button
                            style={{ textAlign: "center" }}
                            variant="contained"
                            color="primary"
                            startIcon={<RefreshIcon />}
                            onClick={() => {
                              queryClient.invalidateQueries("travelerResults");
                            }}
                          />
                        </Tooltip>
                      </Grid>
                      <Grid item xs={5}>
                        <ThreadedCreator
                          id={travelerResults.id}
                          parentObject={travelerResults}
                          model={"unit"}
                          invalidate={[
                            "travelerResults",
                            ["unit_notes", travelerResults.id],
                          ]}
                          noteType={3}
                        />
                      </Grid>
                      <Grid item xs={1} />
                    </Grid>
                  </Grid>
                  <Grid item xs={12} alignItems="center">
                    <Tooltip
                      title="Download Intake Information"
                      placement="right"
                    >
                      <IconButton color="primary" onClick={downloadIntakeData}>
                        {" "}
                        <SaveAltIcon />
                      </IconButton>
                    </Tooltip>
                    <Button color="primary" onClick={handleOpenIntakeDetails}>
                      {"view intake Images"}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                xs={2}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
              >
                <Typography
                  variant="body2"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Procedure
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
              >
                <Typography
                  variant="body2"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Operator
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
              >
                <Typography
                  variant="body2"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Test Date
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
              >
                <Typography
                  variant="body2"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Disposition
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
              >
                <Typography
                  variant="body2"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Reviewer
                </Typography>
              </Grid>
              <Grid
                item
                xs={2}
                className={classes.baseBorder}
                style={{ backgroundColor: "#eeeeee" }}
              >
                <Typography
                  variant="body2"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  Review Date
                </Typography>
              </Grid>
            </Grid>

            <Grid container direction="row">
              {travelerResults.calibration_results?.map((leg: any) => (
                <React.Fragment key={leg.id}>
                  <Grid
                    item
                    xs={2}
                    className={classes.baseBorder}
                    style={{ backgroundColor: "orange" }}
                  >
                    <Typography
                      variant="body2"
                      align="center"
                      style={{ fontWeight: "bold" }}
                    >
                      {leg.linear_execution_group}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    className={classes.baseBorder}
                    style={{ backgroundColor: "orange" }}
                  >
                    <Typography
                      variant="body2"
                      align="center"
                      style={{ fontWeight: "bold" }}
                    >
                      {leg.name}
                    </Typography>
                  </Grid>

                  {leg.procedure_results?.map((procedure: any) => (
                    <React.Fragment key={procedure.id}>
                      <Grid item xs={2} className={classes.baseBorder}>
                        {procedure.completion_date && procedure.visualizer
                          ? renderVisualizerModal(procedure)
                          : renderProcedureName(procedure)}
                      </Grid>

                      <Grid item xs={2} className={classes.baseBorder}>
                        <Typography variant="body2" align="center">
                          {procedure.username ? (
                            <Typography variant="body2" align="center">
                              {procedure.username}
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ color: "grey" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Typography>
                      </Grid>

                      <Grid item xs={2} className={classes.baseBorder}>
                        <Typography variant="body2" align="center">
                          {procedure.completion_date ? (
                            <Typography variant="body2" align="center">
                              {formatDate(procedure.completion_date)}
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ color: "grey" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Typography>
                      </Grid>

                      <Grid item xs={2} className={classes.baseBorder}>
                        <Typography variant="body2" align="center">
                          {procedure.disposition_name ? (
                            <Typography variant="body2" align="center">
                              {procedure.disposition_name}
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ color: "grey" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} className={classes.baseBorder}>
                        <Typography variant="body2" align="center">
                          {procedure.reviewed_by_user ? (
                            <Typography variant="body2" align="center">
                              {procedure.reviewed_by_user}
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ color: "grey" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} className={classes.baseBorder}>
                        <Typography variant="body2" align="center">
                          {procedure.review_datetime ? (
                            <Typography variant="body2" align="center">
                              {formatDate(procedure.review_datetime)}
                            </Typography>
                          ) : (
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ color: "grey" }}
                            >
                              N/A
                            </Typography>
                          )}
                        </Typography>
                      </Grid>
                      {procedure.visualizer === "stress" &&
                        procedure.start_datetime !== null ? (
                        <>
                          <Grid
                            item
                            xs={2}
                            className={classes.baseBorder}
                            style={{ backgroundColor: "#eeeeee" }}
                          >
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ fontWeight: "bold" }}
                            >
                              {"Stressor Data"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.baseBorder}
                            style={{ backgroundColor: "#eeeeee" }}
                          >
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ fontWeight: "bold" }}
                            >
                              {`Start Date:`}
                            </Typography>
                            <Typography variant="body2" align="center">
                              {`${formatDate(procedure.start_datetime)}`}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.baseBorder}
                            style={{ backgroundColor: "#eeeeee" }}
                          >
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ fontWeight: "bold" }}
                            >
                              {"Entered By:"}
                            </Typography>
                            <Typography variant="body2" align="center">
                              {procedure.username}
                            </Typography>
                          </Grid>
                          {procedure.end_datetime !== null ? (
                            <Grid
                              item
                              xs={2}
                              className={classes.baseBorder}
                              style={{ backgroundColor: "#eeeeee" }}
                            >
                              <Typography
                                variant="body2"
                                align="center"
                                style={{ fontWeight: "bold" }}
                              >
                                {"Exit Date"}
                              </Typography>
                              <Typography variant="body2" align="center">
                                {formatDate(procedure.end_datetime)}
                              </Typography>
                            </Grid>
                          ) : (
                            <Grid
                              item
                              xs={2}
                              className={classes.baseBorder}
                              style={{ backgroundColor: "#eeeeee" }}
                            >
                              <Typography
                                variant="body2"
                                align="center"
                                style={{ fontWeight: "bold" }}
                              >
                                {"Estimated Exit Date:"}
                              </Typography>
                              <Typography variant="body2" align="center">
                                {addTime(
                                  procedure.start_datetime,
                                  procedure.duration,
                                )}
                              </Typography>
                            </Grid>
                          )}
                          <Grid
                            item
                            xs={2}
                            className={classes.baseBorder}
                            style={{ backgroundColor: "#eeeeee" }}
                          >
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ fontWeight: "bold" }}
                            >
                              {"Exit User"}
                            </Typography>
                            <Typography variant="body2" align="center">
                              {procedure.exit_user
                                ? procedure.exit_user
                                : "N/A"}
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.baseBorder}
                            style={{ backgroundColor: "#eeeeee" }}
                          >
                            <Typography
                              variant="body2"
                              align="center"
                              style={{ fontWeight: "bold" }}
                            >
                              {" "}
                            </Typography>
                          </Grid>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}

              {travelerResults.sequences_results?.map((leg: any) => (
                <React.Fragment key={leg.id}>
                  <Grid
                    item
                    xs={2}
                    className={classes.baseBorder}
                    style={{ backgroundColor: "yellow" }}
                  >
                    <Typography
                      variant="body2"
                      align="center"
                      style={{ fontWeight: "bold" }}
                    >
                      {leg.linear_execution_group}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    className={classes.baseBorder}
                    style={{ backgroundColor: "#eeeeee" }}
                  >
                    <Typography
                      variant="body2"
                      align="center"
                      style={{ fontWeight: "bold" }}
                    >
                      {leg.name}
                    </Typography>
                  </Grid>

                  {leg.procedure_results?.map((procedure: any) => (
                    <React.Fragment key={procedure.id}>
                      <Tooltip
                        title="Notes have been added to this procedure"
                        arrow
                        disableHoverListener={!procedure.is_comments}
                      >
                        <Grid
                          container
                          key={procedure.id}
                          style={{
                            backgroundColor: procedure.is_comments
                              ? "#8ec9f3"
                              : "transparent",
                          }}
                        >
                          {procedure.final_result ? (
                            <Grid
                              item
                              xs={2}
                              className={classes.baseBorder}
                              style={{ backgroundColor: "lightblue" }}
                            >
                              {procedure.completion_date && procedure.visualizer
                                ? renderVisualizerModal(procedure)
                                : renderProcedureName(procedure)}
                            </Grid>
                          ) : (
                            <Grid item xs={2} className={classes.baseBorder}>
                              {procedure.completion_date && procedure.visualizer
                                ? renderVisualizerModal(procedure)
                                : renderProcedureName(procedure)}
                            </Grid>
                          )}

                          <Grid item xs={2} className={classes.baseBorder}>
                            <Typography variant="body2" align="center">
                              {procedure.username ? (
                                <Typography variant="body2" align="center">
                                  {procedure.username}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ color: "grey" }}
                                >
                                  N/A
                                </Typography>
                              )}
                            </Typography>
                          </Grid>

                          <Grid item xs={2} className={classes.baseBorder}>
                            <Typography variant="body2" align="center">
                              {procedure.completion_date ? (
                                <Typography variant="body2" align="center">
                                  {formatDate(procedure.completion_date)}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ color: "grey" }}
                                >
                                  N/A
                                </Typography>
                              )}
                            </Typography>
                          </Grid>

                          <Grid item xs={2} className={classes.baseBorder}>
                            <Typography variant="body2" align="center">
                              {procedure.disposition_name ? (
                                <Typography variant="body2" align="center">
                                  {procedure.disposition_name}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ color: "grey" }}
                                >
                                  N/A
                                </Typography>
                              )}
                            </Typography>
                          </Grid>
                          <Grid item xs={2} className={classes.baseBorder}>
                            <Typography variant="body2" align="center">
                              {procedure.reviewed_by_user ? (
                                <Typography variant="body2" align="center">
                                  {procedure.reviewed_by_user}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ color: "grey" }}
                                >
                                  N/A
                                </Typography>
                              )}
                            </Typography>
                          </Grid>
                          <Grid item xs={2} className={classes.baseBorder}>
                            <Typography variant="body2" align="center">
                              {procedure.review_datetime ? (
                                <Typography variant="body2" align="center">
                                  {formatDate(procedure.review_datetime)}
                                </Typography>
                              ) : (
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ color: "grey" }}
                                >
                                  N/A
                                </Typography>
                              )}
                            </Typography>
                          </Grid>
                          {procedure.visualizer === "stress" &&
                            procedure.start_datetime !== null ? (
                            <>
                              <Grid
                                item
                                xs={2}
                                className={classes.baseBorder}
                                style={{ backgroundColor: "#eeeeee" }}
                              >
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {"Stressor Data"}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                xs={2}
                                className={classes.baseBorder}
                                style={{ backgroundColor: "#eeeeee" }}
                              >
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {`Start Date:`}
                                </Typography>
                                <Typography variant="body2" align="center">
                                  {`${formatDate(procedure.start_datetime)}`}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                xs={2}
                                className={classes.baseBorder}
                                style={{ backgroundColor: "#eeeeee" }}
                              >
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {"Entered By:"}
                                </Typography>
                                <Typography variant="body2" align="center">
                                  {procedure.username}
                                </Typography>
                              </Grid>
                              {procedure.end_datetime !== null ? (
                                <Grid
                                  item
                                  xs={2}
                                  className={classes.baseBorder}
                                  style={{ backgroundColor: "#eeeeee" }}
                                >
                                  <Typography
                                    variant="body2"
                                    align="center"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {"Exit Date"}
                                  </Typography>
                                  <Typography variant="body2" align="center">
                                    {formatDate(procedure.end_datetime)}
                                  </Typography>
                                </Grid>
                              ) : (
                                <Grid
                                  item
                                  xs={2}
                                  className={classes.baseBorder}
                                  style={{ backgroundColor: "#eeeeee" }}
                                >
                                  <Typography
                                    variant="body2"
                                    align="center"
                                    style={{ fontWeight: "bold" }}
                                  >
                                    {"Estimated Exit Date:"}
                                  </Typography>
                                  <Typography variant="body2" align="center">
                                    {addTime(
                                      procedure.start_datetime,
                                      procedure.duration,
                                    )}
                                  </Typography>
                                </Grid>
                              )}
                              <Grid
                                item
                                xs={2}
                                className={classes.baseBorder}
                                style={{ backgroundColor: "#eeeeee" }}
                              >
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {"Exit User"}
                                </Typography>
                                <Typography variant="body2" align="center">
                                  {procedure.exit_user
                                    ? procedure.exit_user
                                    : "N/A"}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                xs={2}
                                className={classes.baseBorder}
                                style={{ backgroundColor: "#eeeeee" }}
                              >
                                <Typography
                                  variant="body2"
                                  align="center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {" "}
                                </Typography>
                              </Grid>
                            </>
                          ) : null}
                        </Grid>
                      </Tooltip>
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </Grid>
          </>
        )}
      <Dialog
        open={isHistoricModalOpen}
        onClose={() => {
          setIsHistoricModalOpen(false);
          setCurrentHistoricData(null);
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogTitle id="scroll-dialog-title">
          <Typography variant="h4">Visualizer Modal</Typography>
        </DialogTitle>
        <DialogContent dividers={true}>
          <VisualizerModal
            historicData={currentHistoricData}
            unitData={units[0]}
            unitTypeData={travelerResults?.unit_type}
            closeHistoricModal={() => {
              setIsHistoricModalOpen(false);
              setCurrentHistoricData(null);
              queryClient.invalidateQueries("travelerResults");
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsHistoricModalOpen(false);
              setCurrentHistoricData(null);
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <ImageListModal
        open={imageModal}
        setOpen={setImageModal}
        images={travelerResults.unit_images}
      />
      <Dialog
        open={isIntakeDetailOpen}
        onClose={() => {
          setIsIntakeDetailOpen(false);
        }}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        fullWidth={true}
        maxWidth={"xl"}
      >
        <DialogTitle id="scroll-dialog-title">
          <Typography variant="h4">Intake Images</Typography>
        </DialogTitle>
        <DialogContent dividers={true}>
          <IntakeImages serialNumber={serialNumber} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsIntakeDetailOpen(false);
            }}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openChooseProcedureDialog}
        onClose={() => setOpenChooseProcedureDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Choose Stress Procedure</DialogTitle>

        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
            {/* First Dropdown */}
            <Grid item xs={12} sm={6}>
              <MuiTextField
                select
                label="Select Procedure"
                fullWidth
                variant="outlined"
                value={selectedProcedure?.selected_definition_id || ""}
                onChange={(e) => {
                  setSelectedProcedure({
                    ...selectedProcedure,
                    selected_definition_id: e.target.value,
                  });
                }}
              >
                <MenuItem value={17}>Light Soak</MenuItem>
                <MenuItem value={70}>CID</MenuItem>
              </MuiTextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center" }}>
          <Button
            onClick={() => setOpenChooseProcedureDialog(false)}
            variant="outlined"
          >
            Cancel
          </Button>

          <Button
            color="primary"
            variant="contained"
            onClick={handleVerify}
            disabled={submitStressProcedureLoading}
          >
            {submitStressProcedureLoading ? "Verifying..." : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEdgePinchDialog}
        onClose={() => setopenEdgePinchDialog(false)}
        fullWidth
        maxWidth="lg"
      >
        <DialogContent>
          <EdgeRetestComponent
            serialnumber={serialNumber}
            procedure={selectedSerialNumber}
            onSuccess={() => {
              setopenEdgePinchDialog(false);
            }}
          />
        </DialogContent>
      </Dialog>


      <Dialog
        open={openNotesDialog}
        onClose={() => setOpenNotesDialog(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Notes</DialogTitle>

        <DialogContent>
          {isLoading && (
            <Grid container justifyContent="center" style={{ padding: 20 }}>
              <CircularProgress size={24} />
            </Grid>
          )}

          {!isLoading && notes?.length > 0 && (
            <Paper elevation={4} style={{ padding: 12 }}>
              <Grid container spacing={2} style={{ padding: 12 }}>
                {notes.map((note: any, index: number) => (
                  <React.Fragment key={index}>
                    <Grid
                      container
                      direction="row"
                      alignItems="flex-start"
                      spacing={2}
                    >
                      <Grid
                        item
                        xs={5}
                        style={{ marginBottom: 4, marginTop: 8 }}
                      >
                        <Typography variant="body1" display="inline">
                          {note.subject}
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={2}
                        style={{ marginBottom: 4, marginTop: 8 }}
                      >
                        <Typography
                          variant="body2"
                          display="inline"
                          align="right"
                        >
                          From:{note?.created_by || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={2}
                        style={{ marginBottom: 4, marginTop: 8 }}
                      ></Grid>

                      <Grid
                        item
                        xs={3}
                        style={{ marginBottom: 4, marginTop: 8 }}
                      >
                        <Typography
                          variant="body2"
                          display="inline"
                          align="right"
                        >
                          At:{" "}
                          {note?.created_on
                            ? formatDate(note.created_on)
                            : "N/A"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} style={{ marginBottom: 12 }}>
                        <RichTextEditor
                          value={RichTextEditor.createValueFromString(
                            note.comments || "",
                            "markdown",
                          )}
                          readOnly={true}
                        />
                      </Grid>
                    </Grid>
                    <Divider variant="fullWidth" />
                  </React.Fragment>
                ))}
              </Grid>
            </Paper>
          )}

          {!isLoading && (!notes || notes.length === 0) && (
            <Typography align="center">No notes found</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // setOpenNotesDialog(false);
              setOpenAddNoteDialog(true);
            }}
          >
            Add Note
          </Button>

          <Button onClick={() => setOpenNotesDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Formik
        initialValues={{
          subject: "",
        }}
        validationSchema={Yup.object({
          subject: Yup.string().required("Field must be required"),
        })}
        onSubmit={async (Values, { resetForm, setSubmitting }) => {
          try {
            setSubmitting(true);

            let alertUsers = [];
            for (const user of taggedUsers) {
              alertUsers.push(user.id);
            }
            let uploadedFileIds: number[] = [];

            if (files.length > 0) {
              for (const file of files) {
                const postedFile = await mutatePostFile({
                  authAxios,
                  file,
                });

                uploadedFileIds.push(postedFile.id);
              }

              await mutate({
                authAxios,
                procedure_result: selectedProcedureId,
                subject: Values.subject,
                comments: text.toString("markdown"),
                tagged_users: alertUsers,
                azurefiles: uploadedFileIds,
              });
            } else {
              await mutate({
                authAxios,
                procedure_result: selectedProcedureId,
                subject: Values.subject,
                comments: text.toString("markdown"),
                tagged_users: alertUsers,
              });
            }

            toast.success("Note successfully added.");
            queryClient.invalidateQueries("travelerResults");

            setOpenAddNoteDialog(false);
            setOpenNotesDialog(false);

            resetForm();
            setText(RichTextEditor.createEmptyValue());
            setTaggedUsers([]);
            setFiles([]);
          } catch (err) {
            toast.error("Note failed to be added");
            processErrorOnMutation(err);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {({ submitForm, isSubmitting, errors, touched }) => (
          <Form>
            <Dialog
              open={openAddNoteDialog}
              onClose={() => {
                setOpenAddNoteDialog(false);
                setText(RichTextEditor.createEmptyValue());
                setTaggedUsers([]);
                setFiles([]);
              }}
              fullWidth
              maxWidth="lg"
            >
              <DialogTitle>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                  spacing={1}
                >
                  <Grid item xs={8}>
                    <Field
                      name="subject"
                      helperText={touched.subject ? errors.subject : ""}
                      error={touched.subject && Boolean(errors.subject)}
                      component={TextField}
                      label="Note Subject"
                      placeholder="Add a Subject"
                      fullWidth
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <Fade
                      in={isLoading}
                      style={{ transitionDelay: isLoading ? "0ms" : "0ms" }}
                    >
                      <CircularProgress />
                    </Fade>
                  </Grid>
                  <Grid item xs={1}>
                    <IconButton onClick={() => setOpenAddNoteDialog(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </DialogTitle>

              <DialogContent dividers>
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="flex-start"
                  spacing={1}
                >
                  <Grid item xs={8} style={{ marginTop: "12px" }}>
                    <RichTextEditor
                      value={text}
                      onChange={(value) => setText(value)}
                      toolbarConfig={{
                        display: [
                          "INLINE_STYLE_BUTTONS",
                          "BLOCK_ALIGNMENT_BUTTONS",
                          "BLOCK_TYPE_BUTTONS",
                          "BLOCK_TYPE_DROPDOWN",
                          "HISTORY_BUTTONS",
                        ],
                        INLINE_STYLE_BUTTONS: [
                          { label: "Bold", style: "BOLD" },
                          { label: "Italic", style: "ITALIC" },
                          { label: "Strikethrough", style: "STRIKETHROUGH" },
                          { label: "Monospace", style: "CODE" },
                          { label: "Underline", style: "UNDERLINE" },
                        ],
                        BLOCK_ALIGNMENT_BUTTONS: [
                          { label: "UL", style: "unordered-list-item" },
                          { label: "OL", style: "ordered-list-item" },
                          { label: "Blockquote", style: "blockquote" },
                        ],
                        BLOCK_TYPE_DROPDOWN: [
                          { label: "Normal", style: "unstyled" },
                          { label: "Heading Large", style: "header-one" },
                          { label: "Heading Medium", style: "header-two" },
                          { label: "Heading Small", style: "header-three" },
                        ],
                        BLOCK_TYPE_BUTTONS: [
                          { label: "UL", style: "unordered-list-item" },
                          { label: "OL", style: "ordered-list-item" },
                          { label: "Blockquote", style: "blockquote" },
                        ],
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{
                      borderLeftStyle: "solid",
                      borderWidth: "2px",
                    }}
                  >
                    <Grid
                      container
                      direction="column"
                      justify="center"
                      alignItems="stretch"
                      spacing={1}
                    >
                      <Grid item xs={12}>
                        <ThreadedTaggedUsers
                          taggedUsers={taggedUsers}
                          setTaggedUsers={setTaggedUsers}
                          isNew={true}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <ThreadedFileModal
                          files={files}
                          setFiles={setFiles}
                          isNew={true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={() => {
                    setOpenAddNoteDialog(false);

                    setText(RichTextEditor.createEmptyValue());
                    setTaggedUsers([]);
                    setFiles([]);
                  }}
                  color="secondary"
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={submitForm}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save"}
                </Button>
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>

    </Container>
  );
};
